<div class="report-tab-content" [style.height]="this.height + 'px'">
  <div class="sidenav-title">
    <div class="sidenav-report-header">
      <div>{{showExpandCategory[0]}}</div>
    </div>
  </div>

  <!-- Revision History -->
  <app-inspection-report-version [targetReport]="inspectionReport" [generatedReports]="generatedReports"
    [isDeletedInspection]="isDeletedInspection">
  </app-inspection-report-version>

  <div class="sidenav-title">
    <div class="sidenav-report-header">
      <span>
        {{showExpandCategory[1]}}
      </span>
      <div>
        <button mat-raised-button
                [matMenuTriggerFor]="pastReportFilterMenu"
                class="past-report-filter-menu-button">
          <mat-icon>filter_list</mat-icon>{{ filterText(pastFilterControl?.value) || 'inspectionReportTab.filterBy' | translate }}
        </button>
        <mat-menu #pastReportFilterMenu="matMenu">
          <button *ngFor="let pastReportFilter of pastReportFilters"
                  mat-menu-item
                  (click)="changePastReportFilter($event, pastReportFilter)">
            {{ filterText(pastReportFilter) }}
          </button>
        </mat-menu>
      </div>
      <ng-container *ngFor="let subject of subjects">
        <div class="sidenav-title-content" [matTooltip]="subject.serialNo" [matTooltipPosition]="this.tooltipPosition"
          matTooltipClass="tooltip-overflow">
          {{subject.serialNo}}
        </div>
      </ng-container>
    </div>
  </div>

  <!-- Past Reports of Serial -->
  <app-inspection-report-history [targetReport]="inspectionReport" [reports]="historyReports" [isReportLoading]="isReportLoading">
  </app-inspection-report-history>
</div>
